"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const rollbar_1 = __importDefault(require("../utils/development/rollbar"));
const segment_1 = __importDefault(require("../utils/development/segment"));
const sentry_1 = __importDefault(require("../utils/development/sentry"));
function useAsyncEffect(callback, dependencies) {
    return (0, react_1.useEffect)(() => {
        const promise = callback().catch((err) => {
            console.error(`AsyncEffect error: `, err);
            (0, rollbar_1.default)((rollbar) => rollbar.error('AsyncEffect error: ' + err.message, err));
            (0, sentry_1.default)((sentry) => sentry.captureException('AsyncEffect error: ' + err.message, {
                extra: err,
            }));
            (0, segment_1.default)((analytics) => analytics.track('error', {
                ...err,
                message: err.message,
                stack: err.stack,
            }));
        });
        return function () {
            promise.then((unsubscribe) => {
                if (typeof unsubscribe === 'function') {
                    unsubscribe();
                }
            });
        };
    }, dependencies);
}
exports.default = useAsyncEffect;
